<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <!--<button class="add-role" data-toggle="modal" data-target="#exampleModal">Add</button>
             <div class="personal-details">
                <h4 class="personal-details-title">Roles List</h4>
                <table class="table table-striped">
                  <thead>
                        <tr>
                            <th scope="col">Role Name</th>
                            <th scope="col">Created Date</th>
                            <th scope="col">Action</th>
                        </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let role of roles | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: page,
                        totalItems: count
                        };let i=index">
                        <th scope="col">{{role.roleName}}</th>
                        <th scope="col">{{role.createdDate | date:'medium'}}</th>
                        <th scope="col">
                            <span>
                                <i (click)="getRoleById(role.roleId)" data-toggle="modal" data-target="#updateRole" class="bi bi-pencil-square"></i>
                                <i (click)="getRoleById(role.roleId)" data-toggle="modal" data-target="#viewRole" class="bi bi-eye-fill"></i>
                                <i (click)="selectRole(role.id)" data-toggle="modal" data-target="#deleteModal" class="bi bi-trash3"></i>
                            </span>
                        </th>
                    </tr>
                  </tbody>
                </table>
                <div class="pagination-block" *ngIf="roles.length != 0">
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      (pageChange)="onTableDataChange($event)"
                    >
                    </pagination-controls>
                </div>
            </div> -->

            <div class="personal-details">

                <div class="header-block">
                    <div class="header-title">
                        <app-breadcrumb></app-breadcrumb>
                    </div>
                    <div class="add-block">
                        <div class="search">
                            <form autocomplete="off">
                                <input type="text" [ngModelOptions]="{standalone: true}" placeholder="search role"
                                    [(ngModel)]="searchKey">
                            </form>
                            <i class="bi bi-search" (click)="searchByRoleName()"></i>
                        </div>
                        <button data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> {{
                            'generic.add' | translate }}</button>

                        <div class="filter-icon">
                            <i class="bi bi-arrow-clockwise" title="Refresh" (click)="refreshAll()"></i>
                        </div>
                    </div>
                </div>

                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 10%;">{{ 'roles.roleId' | translate }}</th>

                            <th style="width: 35%;">{{ 'roles.roleName' | translate }}</th>
                            <th style="width: 35%;">{{ 'roles.createdDate' | translate }}</th>
                            <th style="width: 20%;text-align: center;padding: 0;">{{ 'generic.action' | translate }}
                            </th>
                        </tr>
                    </thead>
                </table>
                <div *ngIf="!isLoading">
                    <div class="data-view" [ngClass]="{ 'delete-highlight': role.roleId == recordId }" *ngFor="let role of roles | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber,
                        totalItems: totalRecords
                        }  ;let i = index">

                        <p style="width: 10%;">{{role.roleId}}</p>

                        <p style="width: 35%;">{{role.roleName}}</p>
                        <p style="width: 35%;">{{role.createdDate | date:'medium'}}</p>
                        <p class="action-buttons" style="width: 20%">
                            <i (click)="getRoleById1(role.roleId)" data-toggle="modal" data-target="#updateModal"
                                class="bi bi-pencil-square"></i>
                            <i (click)="getRoleById(role.roleId)" data-toggle="modal" data-target="#viewRole"
                                class="bi bi-eye-fill"></i>
                            <i (click)="selectDelete(role.id,role)" data-toggle="modal" data-target="#deleteModal"
                                class="bi bi-trash3"></i>
                        </p>
                    </div>
                </div>


                <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                </div>

                <div class="loader" *ngIf="!isLoading && roles.length == 0">
                    <div class="no-data">
                        <img src="assets/no-data-6.png" alt="">
                        <p>no data found</p>
                    </div>

                </div>

                <div class="paginator">
                    <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize"
                        [totalRecords]="totalRecords" [showFirstLastIcon]="false" [showCurrentPageReport]="true"
                        currentPageReportTemplate="{first} - {last} of {totalRecords}">
                    </p-paginator>
                </div>


            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'roles.headings.add' | translate }}
                    <span data-dismiss="modal" (click)="addRoleClose()">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="form">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-12 col-lg-12">
                                <label>{{ 'roles.roleName' | translate }} <span class="required-field">*</span></label>
                                <input formControlName="roleName" type="text" class="form-control">
                            </div>
                            <div class="col-md-12 col-lg-12">
                                <div class="singleData" *ngFor="let privilege_group of privileges;let i = index">
                                    <div class="single-role-header">
                                        <input (click)="isChecked($event,i)" [checked]="privilege_group.isChecked"
                                            type="checkbox">
                                        <label>{{privilege_group.groupName}}</label>
                                    </div>
                                    <div class="single-role-table">
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th style="width: 5%;">
                                                        <input type="checkbox" (click)="isChecked($event,i)" [checked]="privilege_group.isChecked">
                                                    </th>
                                                    <!-- <th style="width: 5%;">S.No.</th> -->
                                                    <th style="width: 25%;">{{ 'roles.name' | translate }}</th>
                                                    <th style="width: 35%;">{{ 'roles.description' | translate }}</th>
                                                    <th style="width: 40%;">{{ 'roles.permissions' | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let screenPrivilegeList of privilege_group.screenPrivilegeList;let j = index">
                                                    <th><input type="checkbox" (click)="screenCheck($event,i,j)"
                                                            [checked]="screenPrivilegeList.isChecked"></th>
                                                    <!-- <th>{{screenPrivilegeList.seqNo}}</th> -->
                                                    <th>{{screenPrivilegeList.name}}</th>
                                                    <th>{{screenPrivilegeList.description}}</th>
                                                    <th>
                                                        <div class="permissions">
                                                            <p>
                                                                <input type="checkbox" [disabled]="!screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.view"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.view">
                                                                {{ 'roles.view' | translate }}
                                                            </p>
                                                            <p [ngClass]="{'no-access': !screenPrivilegeList.isAdd}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isAdd || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.add"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.add">
                                                                {{ 'roles.add' | translate }}
                                                            </p>
                                                            <p [ngClass]="{'no-access': !screenPrivilegeList.isModify}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isModify || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.modify"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.modify">
                                                                {{ 'roles.modify' | translate }}
                                                            </p>
                                                            <p class=""
                                                                [ngClass]="{'no-access': !screenPrivilegeList.isDelete}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isDelete || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.delete"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.delete">
                                                                {{ 'roles.delete' | translate }}
                                                            </p>



                                                            <p class=""
                                                                [ngClass]="{'no-access': !screenPrivilegeList.isVerify}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isVerify || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.verify"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.verify">
                                                                {{ 'roles.verify' | translate }}
                                                            </p>

                                                            <p class=""
                                                                [ngClass]="{'no-access': !screenPrivilegeList.isApprove}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isApprove || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.approve"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.approve">
                                                                {{ 'roles.approve' | translate }}
                                                            </p>

                                                            <p class=""
                                                                [ngClass]="{'no-access': !screenPrivilegeList.isIssue}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isIssue || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.issue"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.issue">
                                                                {{ 'roles.issue' | translate }}
                                                            </p>

                                                            <p class=""
                                                                [ngClass]="{'no-access': !screenPrivilegeList.isAttach}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isAttach || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.attach"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.attach">
                                                                {{ 'roles.attach' | translate }}
                                                            </p>

                                                            <p class=""
                                                                [ngClass]="{'no-access': !screenPrivilegeList.isRemove}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isRemove || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.remove"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.remove">
                                                                {{ 'roles.remove' | translate }}
                                                            </p>




                                                        </div>
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" id="closeModalButton" class="btn btn-secondary"
                                (click)="addRoleClose()" data-dismiss="modal">{{ 'generic.cancel' | translate
                                }}</button>
                            <button type="button" *ngIf="addButton" (click)="addRole()" class="btn btn-primary">{{
                                'generic.add' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade" id="viewRole" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'roles.headings.detail' | translate }}
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div>
                    <div class="form-group" *ngFor="let role of singleRoleData;">
                        <div class="row">
                            <div class="col-md-12 col-lg-12">
                                <label>{{ 'roles.roleName' | translate }}</label>
                                <input readonly [value]="role.roleName" type="text" class="form-control">
                            </div>
                            <div class="col-md-12 col-lg-12">
                                <div class="singleData"
                                    *ngFor="let screenGroupList of role.screenGroupList;let i = index">
                                    <div class="single-role-header">
                                        <label>{{screenGroupList.groupName}}</label>
                                    </div>
                                    <div class="single-role-table">
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th style="width: 20%;">{{ 'roles.seqNo' | translate }}</th>
                                                    <th style="width: 40%;">{{ 'roles.name' | translate }}</th>
                                                    <th style="width: 40%;">{{ 'roles.description' | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let screenPrivilegeList of screenGroupList.screenPrivilegeList;let j = index">
                                                    <th>{{screenPrivilegeList.seqNo}}</th>
                                                    <th>{{screenPrivilegeList.name}}</th>
                                                    <th>{{screenPrivilegeList.description}}</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" id="closeModalButton" class="btn btn-secondary"
                                data-dismiss="modal">{{ 'generic.close' | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="updateModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ 'roles.headings.edit' | translate }}
                    <span data-dismiss="modal" (click)="addRoleClose()">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="editForm">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-12 col-lg-12">
                                <label>{{ 'roles.roleName' | translate }} <span class="required-field">*</span></label>
                                <input formControlName="roleName" type="text" class="form-control">
                            </div>
                            <div class="col-md-12 col-lg-12">
                                <div class="singleData" *ngFor="let role of privileges1;let i = index">
                                    <div class="single-role-header">
                                        <input (click)="isChecked1($event,i)" [checked]="role.isChecked"
                                            type="checkbox">
                                        <label>{{role.groupName}}</label>
                                    </div>
                                    <div class="single-role-table">
                                        <table class="table table-striped">
                                            <thead>
                                                <tr>
                                                    <th style="width: 5%;"></th>
                                                    <!-- <th style="width: 5%;">S.No.</th> -->
                                                    <th style="width: 25%;">{{ 'roles.name' | translate }}</th>
                                                    <th style="width: 40%;">{{ 'roles.description' | translate }}</th>
                                                    <th style="width: 30%;">{{ 'roles.permissions' | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let screenPrivilegeList of role.screenPrivilegeList;let j = index">
                                                    <th><input type="checkbox" (click)="screenCheck1($event,i,j)"
                                                            [checked]="screenPrivilegeList.isChecked"></th>
                                                    <!-- <th>{{screenPrivilegeList.seqNo}}</th> -->
                                                    <th>{{screenPrivilegeList.name}}</th>
                                                    <th>{{screenPrivilegeList.description}}</th>
                                                    <th>
                                                        <div class="permissions">
                                                            <p>
                                                                <input type="checkbox" [disabled]="!screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.view"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.view" name="" id="">
                                                                {{ 'roles.view' | translate }}
                                                            </p>
                                                            <p [ngClass]="{'no-access': !screenPrivilegeList.isAdd}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isAdd || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.add"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.add" name="" id="">
                                                                {{ 'roles.add' | translate }}
                                                            </p>
                                                            <p [ngClass]="{'no-access': !screenPrivilegeList.isModify}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isModify || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.modify"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.modify" name=""
                                                                    id="">
                                                                {{ 'roles.modify' | translate }}
                                                            </p>
                                                            <p [ngClass]="{'no-access': !screenPrivilegeList.isDelete}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isDelete || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.delete"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.delete" name=""
                                                                    id="">
                                                                {{ 'roles.delete' | translate }}
                                                            </p>




                                                            <p class=""
                                                                [ngClass]="{'no-access': !screenPrivilegeList.isVerify}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isVerify || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.verify"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.verify">
                                                                {{ 'roles.verify' | translate }}
                                                            </p>

                                                            <p class=""
                                                                [ngClass]="{'no-access': !screenPrivilegeList.isApprove}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isApprove || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.approve"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.approve">
                                                                {{ 'roles.approve' | translate }}
                                                            </p>

                                                            <p class=""
                                                                [ngClass]="{'no-access': !screenPrivilegeList.isIssue}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isIssue || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.issue"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.issue">
                                                                {{ 'roles.issue' | translate }}
                                                            </p>

                                                            <p class=""
                                                                [ngClass]="{'no-access': !screenPrivilegeList.isAttach}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isAttach || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.attach"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.attach">
                                                                {{ 'roles.attach' | translate }}
                                                            </p>

                                                            <p class=""
                                                                [ngClass]="{'no-access': !screenPrivilegeList.isRemove}">
                                                                <input type="checkbox"
                                                                    [disabled]="!screenPrivilegeList.isRemove || !screenPrivilegeList.isChecked"
                                                                    [(ngModel)]="screenPrivilegeList.remove"
                                                                    [ngModelOptions]="{standalone: true}"
                                                                    [checked]="screenPrivilegeList.remove">
                                                                {{ 'roles.remove' | translate }}
                                                            </p>

                                                        </div>
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" id="closeModalButton4" (click)="addRoleClose()"
                                class="btn btn-secondary" data-dismiss="modal">{{ 'generic.cancel' | translate
                                }}</button>
                            <button type="button" (click)="updateRole()" class="btn btn-primary">{{ 'generic.save' |
                                translate }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteModalLabel">{{ 'generic.confirmation' | translate }}
                    <span data-dismiss="modal">
                        <i data-dismiss="modal" (click)="cancelModel()" class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <p>{{ 'generic.deleteText' | translate }} <span class="delete-span">“{{recordName}} (ID:
                        {{recordId}})”</span>?</p>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton1" (click)="cancelModel()" class="btn btn-secondary"
                        data-dismiss="modal">{{ 'generic.cancel' | translate }}</button>
                    <button type="button" class="btn btn-primary" (click)="deleteRole()">{{ 'generic.delete' | translate
                        }}</button>
                </div>
            </div>
        </div>
    </div>
</div>

